
export default function processMapProject(mapProject, projectId) {
    let mapProjectProcessed = JSON.parse(JSON.stringify(mapProject));
    mapProjectProcessed.layers.forEach(item => {
        if (item.source && item.source.url) {
            item.source.url = item.source.url.replace(/%PROJECT_ID%/g, projectId)
        }
    });

    return mapProjectProcessed;
}

